module.exports = __webpack_public_path__ + "img/closeicon.68482cc0.svg";